export const localstorageCRUD = () => {
    return {
        create(key, value) {
            if (typeof value === 'object') {
                value = JSON.stringify(value);  // Convertimos el objeto/array a string JSON
            }
            localStorage.setItem(key, value);
        },
        read(key) {
            const value = localStorage.getItem(key);
            try {
                return JSON.parse(value);  // Intentamos convertir de JSON a objeto/array
            } catch (e) {
                return value;  // Si no es un objeto/array, retornamos el valor original
            }
        },
        update(key, newValue) {
            if (typeof newValue === 'object') {
                newValue = JSON.stringify(newValue);  // Convertimos el objeto/array a string JSON
            }
            localStorage.setItem(key, newValue);
        },
        delete(key) {
            localStorage.removeItem(key);
        }
    }
}